import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";

import { Page, Navbar, Fab, List, ListItem, BlockTitle, Icon, AccordionContent, Block, Button, Preloader, Toggle, Searchbar } from "framework7-react";

import _ from "lodash";

// Helpers
import HasRole from "modules/5_view_helpers/HasRole";
import AppNavbar from "modules/1_layout/mobile/AppNavbar";

import SelectProject from "modules/projects/mobile/select";
import { setCurrentProject } from "modules/current_user/actions";

// Actions
import { getProjectQaWeldingInspections } from "../actions";
import moment from "moment";
import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";

import { handleNewClick, ResumePersistedButton } from "modules/5_view_helpers/mobile/PersistedHelpers.jsx";
import { persistedName } from "./vairables";
import PendingSyncBadge from "modules/offline/PendingSyncBadge";

function mapStateToProps(state) {
  return {
    projects: state.projects,
    current_user: state.current_user,
    project_qa_welding_inspections: state.project_qa_welding_inspections,
  };
}

const ProjectQaWeldingInspectionsIndex = (props) => {
  const [loading, setLoading] = useState(false);
  const [showComplete, setShowComplete] = useState(false);
  const { project_qa_welding_inspections, current_user, projects, f7router } = props;
  const current_project_id = _.get(current_user, "current_project_id");
  const project = projects[current_project_id];

  const newUrl = `/project/${project?.id}/qa/welding_inspections/new`;

  let display_project_qa_welding_inspections = _.toArray(project_qa_welding_inspections);
  if (!showComplete) {
    display_project_qa_welding_inspections = _.filter(
      display_project_qa_welding_inspections,
      (welding_inspection) => !welding_inspection.complete || welding_inspection._pendingSync
    );
  }

  display_project_qa_welding_inspections = _.sortBy(display_project_qa_welding_inspections, "assembly.display_name_full");
  const pendingSyncItems = _.filter(display_project_qa_welding_inspections, (item) => item._pendingSync);

  const readRole = HasRole(
    {
      resource_type: "Project::Qa::WeldingInspection",
      name: ["read", "moderator"],
    },
    true
  );

  useEffect(() => {
    if (current_project_id && readRole) {
      setLoading(true);
      props.getProjectQaWeldingInspections(current_project_id).then(() => {
        setLoading(false);
      });
    }
  }, [current_project_id]);

  const createRole = HasRole(
    {
      resource_type: "Project::Qa::WeldingInspection",
      name: ["create", "moderator"],
    },
    true
  );

  const updateRole = HasRole(
    {
      resource_type: "Project::Qa::WeldingInspection",
      name: ["update", "moderator"],
    },
    true
  );

  if (!readRole) {
    return <NotAuthorized />;
  }
  return (
    <Page>
      <AppNavbar title="Welding Inspections" />

      <SelectProject
        onChange={({ target: { value } }) => {
          props.setCurrentProject(value);
        }}
        value={current_project_id}
      />
      <ResumePersistedButton name={persistedName} url={newUrl} />

      {/* <List>
        <ListItem>
          Show Complete
          <Toggle
            checked={showComplete}
            onChange={() => {
              setShowComplete(!showComplete);
            }}
          />
        </ListItem>
      </List> */}

      {loading && <Preloader />}
      {!loading && (
        <Fragment>
          {_.isNotEmpty(pendingSyncItems) && (
            <Fragment>
              <BlockTitle>Needs syncing</BlockTitle>
              <List accordionList>
                {_.map(pendingSyncItems, (welding_inspection) => (
                  <WeldingInspectionRow
                    welding_inspection={welding_inspection}
                    key={`pending-${welding_inspection.id}`}
                    updateRole={updateRole}
                  />
                ))}
              </List>
            </Fragment>
          )}
          <BlockTitle>
            {project?.display_name} - Welding Inspections - Count : {display_project_qa_welding_inspections.length}
          </BlockTitle>
          <Searchbar searchContainer=".search-list" searchIn=".item-title" />

          <List accordionList className="search-list searchbar-found">
            {_.map(display_project_qa_welding_inspections, (welding_inspection, i) => (
              <WeldingInspectionRow welding_inspection={welding_inspection} slot="list" key={i} updateRole={updateRole} />
            ))}
          </List>
          {_.isEmpty(display_project_qa_welding_inspections) && (
            <List>
              <ListItem>No Welding Inspections to do</ListItem>
            </List>
          )}
        </Fragment>
      )}

      {createRole && (
        <Fab
          position="right-bottom"
          slot="fixed"
          text="New"
          href=""
          onClick={() => {
            handleNewClick(f7router, persistedName, newUrl);
          }}
        >
          <Icon ios="f7:plus" aurora="f7:plus" md="material:add"></Icon>
        </Fab>
      )}
    </Page>
  );
};
export default connect(mapStateToProps, { getProjectQaWeldingInspections, setCurrentProject })(ProjectQaWeldingInspectionsIndex);

const WeldingInspectionRow = (props) => {
  const { welding_inspection, updateRole } = props;

  return (
    <ListItem
      accordionItem
      title={welding_inspection?.assembly?.display_name_full || welding_inspection?.display_name_full || "Pending inspection"}
      style={{ backgroundColor: welding_inspection?._pendingSync ? "#fff3e0" : welding_inspection?.complete && "green" }}
    >
      <PendingSyncBadge item={welding_inspection} />
      <AccordionContent>
        <Block>
          <dl>
            <dt>Assembly Name :</dt>
            <dd>{welding_inspection?.display_name_full}</dd>

            <dt>Phase :</dt>
            <dd>{welding_inspection?.assembly?.phase}</dd>

            <dt>Lot :</dt>
            <dd>{welding_inspection?.assembly?.lot}</dd>

            <dt>Inspection Number</dt>
            <dd>{welding_inspection?.number}</dd>

            <dt>Inspection Date</dt>
            <dd>{welding_inspection?.date && moment(welding_inspection.date).format("DD/MM/YYYY")}</dd>

            <dt>Complies</dt>
            <dd>{welding_inspection?.complies ? "Yes" : "No"}</dd>
          </dl>

          <Button
            external
            href={`/project/${welding_inspection?.assembly?.project_id}/qa/welding_inspections/${welding_inspection.id}.pdf`}
            target="_blank"
            fill
            color="green"
          >
            Report
          </Button>

          {updateRole && (
            <Button
              className="margin-top"
              href={`/project/${welding_inspection?.assembly?.project_id || welding_inspection?.project_id}/qa/welding_inspections/${welding_inspection?.id}/edit`}
              fill
            >
              Edit
            </Button>
          )}
        </Block>
      </AccordionContent>
    </ListItem>
  );
};
